import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ConditionsHelper {
  static allObjectsExist(...objects: any[]): boolean {
    return objects.every(obj => Boolean(obj));
  }
}
